import { ArrowDown, ArrowUp } from 'react-feather';
import { Card, CardBody } from 'reactstrap';
import { CommonRadialProgressPropsType } from '../../../Type/WidgetsType';
import { H5, H6, P } from '../../../AbstractElements';
import RadialProgressChart from './RadialProgressChart';

const CommonRadialProgress = ({ data }:CommonRadialProgressPropsType) => {
  return (
    <Card>
      <CardBody className='radial-progress-card'>
        <div>
          <H6 className= 'mb-0'>{data.title}</H6>
          <div className='sale-details'>
            <H5 className= {`font-${data.color} mb-0`} >{data.average}</H5>
            <span className='f-12 f-light f-w-500'>
              {data.gros >= 1.5 ? <ArrowUp /> : <ArrowDown />}
              {data.gros >= 1.5 ? '+' : '-'}
              {data.gros}%
            </span>
          </div>
          <P className= 'f-light' > {data.subTitle}</P>
        </div>
        <div className='radial-chart-wrap'>
          <RadialProgressChart data={data} />
        </div>
      </CardBody>
    </Card>
  );
};

export default CommonRadialProgress;
